import React, { useState, useEffect } from 'react';
import { detectUserLocation, isLocationInIndia, getDefaultMapCenter } from '../utils/locationUtils';

const LocationTest = () => {
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const testLocation = async () => {
      try {
        console.log('Testing location detection...');
        console.log('Geolocation available:', !!navigator.geolocation);
        
        const detectedLocation = await detectUserLocation();
        console.log('Detected location:', detectedLocation);
        setLocation(detectedLocation);
      } catch (err) {
        console.error('Location test error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    testLocation();
  }, []);

  if (loading) {
    return <div>Testing location detection...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ padding: '20px', border: '1px solid #ccc', margin: '20px' }}>
      <h3>Location Detection Test</h3>
      {location ? (
        <div>
          <p><strong>Latitude:</strong> {location.lat}</p>
          <p><strong>Longitude:</strong> {location.lng}</p>
          <p><strong>Country Code:</strong> {location.country_code || 'Unknown'}</p>
          <p><strong>Country Name:</strong> {location.country_name || 'Unknown'}</p>
          <p><strong>In India:</strong> {isLocationInIndia(location) ? 'Yes' : 'No'}</p>
          <p><strong>Map Center:</strong> {JSON.stringify(getDefaultMapCenter(location))}</p>
        </div>
      ) : (
        <p>No location detected</p>
      )}
    </div>
  );
};

export default LocationTest;
